import { Component, inject, OnInit, Optional } from '@angular/core';
import { lastValueFrom, Observable } from 'rxjs';
import TablePagination from '../../interfaces/table/tablePagination';
import { SwalService } from '../../services/swal.service';
import PaginationFilter from '../../interfaces/table/paginationFilter';
import PaginatedResponse from '../../../core/data/models/baseModels/paginatedResponse';
import filterBy from '../../functions/filterBy';
import { LocalPaginationService } from '../../services/local-pagination.service';

@Component({
  selector: 'shared-base-list',
  template: '',
  standalone: false,
})
export default abstract class BaseListComponent<T> implements OnInit {
  request?: (pagination?: PaginationFilter) => Observable<PaginatedResponse<T>>;

  pagination: TablePagination = {
    currentPage: 1,
    totalPages: 1,
  };
  paginationFilter: PaginationFilter = {
    page: 1,
    pageSize: 15,
  };
  filteredData: T[] = [];
  filterParams: any[] = [];
  @Optional() protected localPaginationService? = inject(
    LocalPaginationService<T>,
  );
  private readonly alertService = inject(SwalService);

  private _data: T[] = [];

  get data() {
    return this._data;
  }

  set data(value: T[]) {
    this._data = value;
    this.filteredData = value;
  }

  ngOnInit() {
    this.getData();
  }

  async getData(showLoading = true) {
    if (!this.request) return;

    if (showLoading) this.alertService.showLoading();

    const response = await lastValueFrom(this.request(this.paginationFilter));

    this._data = response.data;

    this.pagination = {
      currentPage: this.paginationFilter.page,
      totalPages:
        Math.ceil(response.totalItems / this.paginationFilter.pageSize) || 1,
    };

    if (showLoading) {
      this.alertService.dismiss();
    }
  }

  paginateNext() {
    if (this.paginationFilter.page < this.pagination.totalPages)
      this.paginationFilter.page += 1;

    this.getData();
  }

  paginatePrev() {
    if (this.paginationFilter.page > 0) this.paginationFilter.page -= 1;

    this.getData();
  }

  async handleSearch($event: string) {
    this.filteredData = filterBy(this._data, $event, this.filterParams);

    this.localPaginationService!.data = this.filteredData;
    this.pagination.currentPage = this.localPaginationService!.currentPage;
    this.pagination.totalPages = this.localPaginationService!.totalPages;
  }
}
